export const headerKeysToFilter = ['x-api-key', 'keyid'];

export const FORM_VALIDATION_ERROR_NAME = 'Form validation error';
export const FORM_VALIDATION_ERROR_TYPE = {
  CUSTOM: 'custom',
  NATIVE: 'native',
};

// filter certain `headers` properties from being logged
export const filterOptionsDetails = (options) => {
  // if (!options) return {};
  if (!options) return null;

  try {
    const { headers = {}, ...restOptions } = options;

    const filteredHeader = Object.keys(headers).reduce((filteredObj, key) => {
      if (!headerKeysToFilter.includes(key?.toLowerCase())) {
        return { ...filteredObj, [key]: headers[`${key}`] };
      }
      return filteredObj;
    }, {});

    return { headers: { ...filteredHeader }, ...restOptions };
  } catch {
    return {};
  }
};

// organise error for logging
export const getErrorMessages = (error) => {
  if (!error) return {};

  const errorMessages = {
    status: error?.status,
    statusCode: error?.statusCode,
    statusText: error?.statusText,
    message: error?.message,
    stack: error?.stack,
  };

  return errorMessages;
};

// extract field errors data from widget error keys
export const extractFieldErrorsFromWidgetErrorKeys = (widgetErrorKeys = [], leadData = {}) => {
  return widgetErrorKeys.reduce((acc, errKey) => {
    if (!errKey) return acc;

    const [group, field] = errKey.split('.');

    if (!group && !field) return acc;

    acc.push({
      fieldGroupName: group,
      fieldName: field,
      value: leadData?.[`${group}`]?.[`${field}`] || '',
    });

    return acc;
  }, []);
};

//  get list of invaid form fiels with native validation errorsx
export const getInvalidFormFields = (form) => {
  const seenRadioGroups = new Set();

  return Array.from(form.elements).filter((el) => {
    const isValidatable =
      el instanceof HTMLInputElement ||
      el instanceof HTMLSelectElement ||
      el instanceof HTMLTextAreaElement;

    if (!isValidatable || el?.validity?.valid) return false;

    /*
      with radio groups, if invalid, all options are included.
      so selecting only one option for each group.
    */
    if (el?.type === 'radio') {
      if (seenRadioGroups.has(el.name)) return false;

      const group = form.querySelectorAll(`input[name="${el.name}"]`);
      const isAnyChecked = Array.from(group).some((input) => input.checked);

      seenRadioGroups.add(el.name);
      return !isAnyChecked;
    }

    return true;
  });
};

// extract field errors data from native form validation
export const extractFieldErrorsFromNativeFormError = (form, invalidFields) => {
  if (!form || !Array.isArray(invalidFields) || invalidFields.length < 1) return [];

  return invalidFields.map((element) => {
    let { value } = element;

    /*
      with radio buttons, we need to get the `checked value`, not value.
      also checking the radio group if any option is checked.
    */
    if (element?.type === 'radio') {
      const group = form.querySelectorAll(`input[name="${element.name}"]`);
      const checked = Array.from(group).find((el) => el.checked);
      value = checked?.value || '';
    }

    return {
      fieldName: element.name || element.id,
      value,
      validationMessage: element.validationMessage,
      validity: element.validity,
    };
  });
};
